export enum PAGE_NAME {
  PERSONAL_INFO = 1,
  SELECT_YOUR_PLAN = 2,
  PICK_ADD_ONS = 3,
  FINISHINGUP = 4,
  CONFIRMING = 5
}